var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.13289 28.9524H27.2098C29.538 28.9524 30.9898 27.2815 30.9898 25.1725C30.9898 24.5425 30.8254 23.8988 30.4829 23.3099L19.9239 4.91731C19.2118 3.67107 17.9518 3 16.6782 3C15.3908 3 14.1309 3.67107 13.4187 4.91731L2.85975 23.3236C2.51738 23.9125 2.35303 24.5425 2.35303 25.1725C2.35303 27.2815 3.80471 28.9524 6.13289 28.9524Z",
    fill: "url(#paint0_linear_20062_392964)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7163 18.6262C17.7026 19.3383 17.3328 19.7218 16.6755 19.7218C15.9907 19.7218 15.6072 19.3246 15.5935 18.6262L15.4155 11.3951C15.4018 10.6967 15.9222 10.1899 16.6617 10.1899C17.3876 10.1899 17.9354 10.7104 17.9217 11.4088L17.7163 18.6262ZM18.1545 22.7483C18.1545 23.5426 17.456 24.1726 16.6754 24.1726C15.881 24.1726 15.1963 23.5289 15.1963 22.7483C15.1963 21.954 15.8674 21.324 16.6754 21.324C17.4697 21.324 18.1545 21.9403 18.1545 22.7483Z",
    fill: "url(#paint1_linear_20062_392964)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20062_392964",
    x1: 2.35303,
    y1: 3,
    x2: 2.35303,
    y2: 28.9524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20062_392964",
    x1: 15.1963,
    y1: 10.1899,
    x2: 15.1963,
    y2: 24.1725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.a72619c40149775a484f0aee228a667e.svg";
export { ForwardRef as ReactComponent };